module.exports = __webpack_public_path__ + "img/logo.18b0377a.png";